import { gql } from '@apollo/client';

import {
  BRAND_TRANSLATIONS_FRAGMENT,
  RETURN_INSTRUCTION_SET_FRAGMENT,
  RETURN_REASON_SET_FRAGMENT,
} from './fragments';

export const RETURNS_APPROVE_PRODUCT = gql`
  mutation Mutation($productId: String!, $returnId: ID!) {
    Returns_ApproveProduct(productId: $productId, returnId: $returnId)
  }
`;

export const RETURNS_REJECT_PRODUCT = gql`
  mutation Returns_RejectProduct($productId: String!, $returnId: ID!) {
    Returns_RejectProduct(productId: $productId, returnId: $returnId)
  }
`;

export const RETURNS_RESET_PRODUCT = gql`
  mutation Returns_ResetProduct($productId: String!, $returnId: ID!) {
    Returns_ResetProduct(productId: $productId, returnId: $returnId)
  }
`;

export const RETURNS_APPROVE_EXCHANGE = gql`
  mutation Returns_ApproveExchange($returnId: ID!) {
    Returns_ApproveExchange(returnId: $returnId)
  }
`;

export const RETURNS_REJECT_EXCHANGE = gql`
  mutation Returns_RejectExchange($returnId: ID!) {
    Returns_RejectExchange(returnId: $returnId)
  }
`;

export const RETURNS_RESET_EXCHANGE = gql`
  mutation Returns_ResetExchange($returnId: ID!) {
    Returns_ResetExchange(returnId: $returnId)
  }
`;

export const RETURNS_PROCESSING = gql`
  mutation Returns_ProcessManualApprove($returnId: ID!) {
    Returns_ProcessManualApprove(returnId: $returnId)
  }
`;

export const RETURN_REASON_SET_UPDATE_MANY_MUTATION = gql`
  mutation ReturnReasonSetUpdateManyMutation(
    $reasonSets: [ReasonSetInput!]!
    $setsToRemove: [String!]!
    $reasonsToRemove: [String!]!
  ) {
    ReturnReasonSet_DeleteMany(ids: $setsToRemove)
    ReturnReason_DeleteMany(ids: $reasonsToRemove)

    ReturnReasonSet_GetAll: ReturnReasonSet_UpdateMany(reasonSets: $reasonSets) {
      ...ReturnReasonSet
    }
  }

  ${RETURN_REASON_SET_FRAGMENT}
`;

export const RETURN_INSTRUCTION_SET_UPDATE_MANY_MUTATION = gql`
  mutation ReturnInstructionSetUpdateManyMutation(
    $sets: [InstructionSetInput!]!
    $setsToRemove: [String!]!
    $stepsToRemove: [String!]!
  ) {
    ReturnInstructionSet_DeleteMany(ids: $setsToRemove)
    ReturnInstructionStep_DeleteMany(ids: $stepsToRemove)
    ReturnInstructionSet_GetAll: ReturnInstructionSet_UpdateMany(instructionSet: $sets) {
      ...ReturnInstructionSet
    }
  }
  ${RETURN_INSTRUCTION_SET_FRAGMENT}
`;

export const RETURNS_TRANSLATIONS_MUTATION = gql`
  mutation BrandTranslationsMutation($id: String!, $input: [TranslationInput!]!) {
    translation: translation_batchUpdate(brandId: $id, input: $input) {
      ...BrandTranslations
    }
  }
  ${BRAND_TRANSLATIONS_FRAGMENT}
`;

export const BATCH_UPDATE_QUESTIONS_ANSWERS = gql(`
  mutation QuestionsAndAnswers_batch($brandId: String!, $createInput: [CreateQuestionsAndAnswersInput!]!, $updateInput: [UpdateQuestionsAndAnswersInput!]!, $deleteInput: [String!]!) {
    QuestionsAndAnswers_create(brandId: $brandId, input: $createInput) {
      id
    }
    QuestionsAndAnswers_update(input: $updateInput) {
      id
    }
    QuestionsAndAnswers_delete(input: $deleteInput)
  }
`);

export const DELETE_RULE_MUTATION = gql(/* GraphQL */ `
  mutation ReturnRules_DeleteOne($input: IdInput!) {
    ReturnRules_DeleteOne(input: $input) {
      success
    }
  }
`);

export const SET_INDEX_MUTATION = gql(/* GraphQL */ `
  mutation ReturnRules_SetIndex($input: ReturnRulesInputSetIndex!) {
    ReturnRules_SetIndex(input: $input) {
      success
    }
  }
`);

export const UPDATE_RULE_MUTATION = gql`
  mutation ReturnRules_UpdateOne($input: ReturnRulesInputUpdateOne!) {
    ReturnRules_UpdateOne(input: $input) {
      id
    }
  }
`;

export const CREATE_RULE_MUTATION = gql`
  mutation ReturnRules_CreateOne($input: ReturnRulesInputCreateOne!) {
    ReturnRules_CreateOne(input: $input) {
      id
    }
  }
`;

export const DUPLICATE_RULE_REASON_MUTATION = gql(/* GraphQL */ `
  mutation ReturnRules_Duplicate($input: IdInput!) {
    ReturnRules_Duplicate(input: $input) {
      id
    }
  }
`);

export const UPDATE_CLIENT_INFO_MUTATION = gql(`
  mutation Return_UpdateClientInfo($input: ReturnsInputUpdateClientInfo!) {
    Return_UpdateClientInfo(input: $input) {
     clientInfo {
      address
      city
      company
      countryCode
      email
      name
      phone
      postcode
      state
      }
    }
  }
`);
